'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('./damo/index');

var _index2 = _interopRequireDefault(_index);

var _beatle = require('./base/beatle');

var _beatle2 = _interopRequireDefault(_beatle);

var _reactRouterDom = require('react-router-dom');

var _ajax = require('./utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _poller = require('./utils/poller');

var _poller2 = _interopRequireDefault(_poller);

var _seed = require('./seed');

var _seed2 = _interopRequireDefault(_seed);

var _model = require('./base/model');

var _model2 = _interopRequireDefault(_model);

var _resource = require('./base/resource');

var _resource2 = _interopRequireDefault(_resource);

var _warning = require('fbjs/lib/warning');

var _warning2 = _interopRequireDefault(_warning);

var _messages = require('./core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _stateObserver = require('./seed/stateObserver');

var _stateObserver2 = _interopRequireDefault(_stateObserver);

var _isReactComponent = require('./core/isReactComponent');

var _isReactComponent2 = _interopRequireDefault(_isReactComponent);

var _substitute = require('./core/substitute');

var _substitute2 = _interopRequireDefault(_substitute);

var _extractModules = require('./core/extractModules');

var _extractModules2 = _interopRequireDefault(_extractModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ### 提供Link标签，对react-router的Link标签做了Hoc
 *
 *  * 兼容原生Link的所有特性
 *  * 带上根路径和全局参数
 *
 * ```
 *  const app = new Beatle({
 *    query: {
 *      debug: true
 *    }
 *  })
 *  // 实际上跳转到/example/message?debug=true
 *  const Message = (props) => {
 *    return (<Beatle.Link to="/message">跳转</Beatle.Link>)
 *  }
 *  // 配置了路由
 *  app.route('/message', Message);
 *  // 设置跟路由
 *  app.run('example');
 * ```
 */
var BeatleLink = (_temp = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(BeatleLink, _React$PureComponent);

  function BeatleLink() {
    (0, _classCallCheck3.default)(this, BeatleLink);
    return (0, _possibleConstructorReturn3.default)(this, (BeatleLink.__proto__ || Object.getPrototypeOf(BeatleLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(BeatleLink, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var app = this.context.app;
      var route = typeof props.to === 'string' ? app.route(props.to) : null;
      var to = route && app.getResolvePath(route, true) || props.to;
      var query = Object.assign(props.query || {}, app._setting.query);
      var basePath = app.parent ? app.parent._setting.basePath : app._setting.basePath;
      var len = basePath.length;
      if (len && to.substr(0, len) === basePath) {
        to = to.slice(len);
      }
      var newProps = {
        to: {
          pathname: to,
          query: query,
          hash: props.hash,
          state: props.state
        }
      };
      // #! inherit Link props
      ['activeStyle', 'activeClassName', 'onlyActiveOnIndex', 'onClick', 'target', 'className', 'style'].forEach(function (key) {
        return newProps[key] = props[key];
      });

      return _react2.default.createElement(
        _reactRouterDom.Link,
        newProps,
        props.children
      );
    }
  }]);
  return BeatleLink;
}(_react2.default.PureComponent), _class.contextTypes = {
  app: _propTypes2.default.object
}, _temp);

/**
 * ### 扩展Beatle静态属性
 *
 * ```
 * const app = new Beatle();
 * // 本身Beatle实例的方法
 * app.route(...)
 * app.model(...)
 * // 可直接通过Beatle来使用
 * Beatle.route(...)
 * Beatle.model(...)
 * // 前提Beatle调用值基于主应用的实例来触发方法
 * // 比如以下就不等同
 * const subApp = new Beatle({subApp: true});
 * subApp.route(...) != Beatle.route(...)
 * ```
 */

function mixinApiToStatic(ClassObj, appName) {
  var apiMethods = ['getStore', 'getRoutes', 'use', 'getResolvePath', 'route', 'mount', 'routesFactory', 'model', 'connect', 'route', 'toBindings', 'run', 'observer', 'view'];
  apiMethods.forEach(function (method) {
    ClassObj[method] = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (docorators[method] && this === undefined) {
        return docorators[method].call(BeatlePro, args[0]);
      } else {
        var app = void 0;
        var fireName = void 0;
        if (appName) {
          app = BeatlePro.instances[appName];
          fireName = appName;
        } else {
          app = BeatlePro.defaultApp;
          fireName = app ? app._setting.appName : '__anonymous__';
        }
        if (app) {
          return app[method].apply(app, args);
        } else {
          var callback = BeatlePro.toLazy(function (theApp) {
            return theApp[method].apply(theApp, args);
          });
          BeatlePro.fireCallbacks[fireName] = BeatlePro.fireCallbacks[fireName] || [];
          BeatlePro.fireCallbacks[fireName].push(callback);
          return callback;
        }
      }
    };
  });
  return ClassObj;
}

Object.assign(_beatle2.default, {
  /**
   * ### Beatle静态方法
   *
   * | 方法 | 参数类型 | 描述 |
   * |: ------ |: ------ |: ------ |
   * | getApp(appName) `BeatleInstance`  | appName `String` | 传入实例名称，获取Beatle实例 |
   * | createModel(Model[, Resource]) | Model `Object`, Resource `Object`| 通过映射Resource来创建Model |
   *
   * > 其他静态方法，均为Beatle的开放Api，Api通过静态方法来调用，最终交给主应用来执行返回。
   * > 比如`Beatle.model(...)` 等同于 `Beatle.getApp(mainAppName).model(...)`
   */
  getApp: function getApp(appName) {
    if (_beatle2.default.instances[appName]) {
      return _beatle2.default.instances[appName];
    } else {
      return mixinApiToStatic({}, appName);
    }
  },
  createModel: function createModel(Model, Resource) {
    if (this !== BeatlePro) {
      // for decorator model
      // !TODO 可能有问题
      return docorators.createModel.call(_beatle2.default, Model);
    } else {
      // #! 校验失败应该返回错误信息 see: https://github.com/facebook/prop-types/issues/142
      if (Model) {
        (0, _model2.default)(Model, 'model');
        if (Resource) {
          (0, _resource2.default)(Resource, 'resource');
          return _seed2.default.createModel(Model, Resource);
        } else {
          return Model;
        }
      } else {
        (0, _warning2.default)(false, _messages2.default.invalidValue, 'arguments', 'Model', Model, 'Beatle.createModel', 'ModelShape');
      }
    }
  },
  toLazy: function toLazy(callback) {
    var fn = function fn(theApp) {
      return fn._result = callback(theApp);
    };
    fn._lazy = true;
    return fn;
  },
  fromLazy: function fromLazy(fn, theApp) {
    if (fn._lazy) {
      if (fn._result) {
        return fn._result;
      } else {
        return fn(theApp);
      }
    } else {
      return fn;
    }
  },

  /**
   * ### mixin静态对象
   *
   * | 对象 | 描述 |
   * |: ------ |: ------ |
   * | Link | 路由跳转组件 |
   * | Ajax | 接口调用模块 |
   * | Poller | 轮询调用模块 |
   * | ReduxSeed | 专门处理Redux的模块 |
   *
   * > 其中`Ajax`, `Poller`, `ReduxSeed` 在你要支持多实例时将特别需要。
   */
  Ajax: _ajax2.default,
  Poller: _poller2.default,
  ReduxSeed: _seed2.default,
  Link: BeatleLink,
  StateObserver: _stateObserver2.default,

  isReactComponent: _isReactComponent2.default,
  substitute: _substitute2.default,
  extractModules: _extractModules2.default
});

mixinApiToStatic(_beatle2.default);

function getDecorator(fn) {
  return function () {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (BaseComponent) {
      var app = typeof option.app === 'string' ? _beatle2.default.getApp(option.app) : option.app || _beatle2.default.defaultApp;
      // if (!app) {
      //   warning(false, messages.appoint, name, 'Beatle');
      // }
      //  || Beatle
      return fn(app, option, BaseComponent);
    };
  };
}

var docorators = {
  // decorator for connect
  connect: getDecorator(function (app, option, BaseComponent) {
    if (typeof app === 'string') {
      app = _beatle2.default.getApp(app);
    }
    return app.connect(option.bindings, BaseComponent, option.flattern);
  }),
  // docorator for model
  model: getDecorator(function (app, option, Model) {
    if (typeof app === 'string') {
      app = _beatle2.default.getApp(app);
    }
    return app.model(Model, option.Resource);
  }),
  // decorator for createModel
  createModel: function createModel(Resource) {
    return function (Model) {
      return BeatlePro.createModel(Model, Resource);
    };
  },
  // docorator for route
  route: getDecorator(function (app, option, BaseComponent) {
    if (typeof app === 'string') {
      app = _beatle2.default.getApp(app);
    }
    if (option.routeOptions) {
      BaseComponent.routeOptions = Object.assign(BaseComponent.routeOptions || {}, option.routeOptions);
    }
    return app.route(option.path, BaseComponent);
  }),
  // docorator for observer
  observer: getDecorator(function (app, option, BaseComponent) {
    if (typeof app === 'string') {
      app = _beatle2.default.getApp(app);
    }
    return app.observer(option.inject, BaseComponent);
  }),
  // decorator for view
  view: getDecorator(function (app, option, BaseComponent) {
    if (typeof app === 'string') {
      app = _beatle2.default.getApp(app);
    }
    return app.view(option.selector, BaseComponent, option.providers, option.bindings, option.hookActions, option.props, option.getProps, option.flattern);
  })
};

var BeatlePro = (0, _index2.default)(_beatle2.default);

['push', 'replace', 'go', 'goBack', 'goForward'].forEach(function (method) {
  BeatlePro.prototype[method] = function (path, state) {
    if (!this._activeHistory) return;
    if (typeof path === 'string') {
      var routeConfig = this.route(path);
      if (routeConfig) {
        path = this.getResolvePath(routeConfig);
      }
    }
    this._activeHistory[method](path, state);
  };
});

BeatlePro.prototype.version = '2.1.4';
module.exports = BeatlePro;

exports.default = BeatlePro;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 92
// module chunks = 0